module.exports = __webpack_public_path__ + "img/home-bg.d90236d2.png";